import { Box, FormHelperText } from '@mui/material';

import { Text } from 'common';

export function PatientInsuranceInformationFormFields() {
  return (
    <Box>
      <Text>No configuration required</Text>
      <FormHelperText>Extract Patient Insurance Information from Notable databases.</FormHelperText>
    </Box>
  );
}
